import { render } from "./LoadDropDown.vue?vue&type=template&id=2975e43c"
import script from "./LoadDropDown.vue?vue&type=script&lang=js"
export * from "./LoadDropDown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__